import RatingTpl from '@virtus/components/DataGrid/cellTemplates/RatingTpl';
import { forEach, keys } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import DateTimeTpl from '../utils/DateTimeTpl';

// import {
//   DateFilter,
//   dateFilterMethod,
//   DefaultFilter,
//   defaultFilterMethod,
//   RangeFilter,
//   rangeFilterMethod,
//   SelectFilter,
//   selectFilterMethod,
// } from '@virtus/components/DataGrid/filters';
import { DataGridColumn } from '@virtus/components/DataGrid/models';
import { ErrorDetailsActiveColumns, ErrorDetailsBaseColumns } from '../constants/errorDetails.const';
import { ErrorDetailsProperties } from '../constants/errorDetails.enum';

const defaultColumnCommonValues = {
  headerStyle: {
    color: '#484848',
    backgroundColor: '#eee',
    width: '100%',
  },
};

const defaultCell = (props: any) => <DefaultCell data-testid="default-cell">{props.value}</DefaultCell>;

const getCell = (templateName: string, ratingColors?: any) => {
  // if (templateName === 'RatingTpl') {
  //   return (props: any) => (
  //     <RatingTpl ratingColors={ratingColors} value={props.value ? props.value.toLowerCase() : ''} />
  //   );
  // }
  if (templateName === 'DateTimeTpl') {
    return (props: any) => <DateTimeTpl value={props.value +'.000z'} />;
  }
  return defaultCell;
};

const getHeader = (headerText: string, accessor: string) => <DefaultHeader id={accessor}>{headerText}</DefaultHeader>;

const getFilter = (filterName: string, filterValues?: any[], filterPlaceholder?: string) => {
  // if (filterName === 'RangeFilter') {
  //   return {
  //     Filter: ({ onChange }: { onChange: () => void }) => <RangeFilter data-testid="rangefilter" onChange={onChange} />,
  //     filterMethod: rangeFilterMethod,
  //   };
  // }
  // if (filterName === 'SelectFilter' && filterValues) {
  //   return {
  //     Filter: (props: any) => <SelectFilter {...props} filterValues={filterValues} />,
  //     filterMethod: selectFilterMethod,
  //   };
  // }
  // if (filterName === 'DateFilter') {
  //   return {
  //     Filter: (props: any) => <DateFilter data-testid="datefilter" {...props} />,
  //     filterMethod: dateFilterMethod,
  //   };
  // }
  return {
    Filter: (props: any) => <DefaultFilter {...props} placeholder={filterPlaceholder} />,
    filterMethod:''// defaultFilterMethod,
  };
};

const getActiveColumns = () => {
  const active = Object.keys(ErrorDetailsActiveColumns).filter(column => ErrorDetailsActiveColumns[column]);
  return Object.entries(ErrorDetailsBaseColumns)
    .filter(column => active.indexOf(column[0]) !== -1)
    .reduce((obj, [k, v]) => ({ ...obj, [k]: v }), {});
};

const processColumnsConfig = (properties: any) => {
  const activeColumns: any = getActiveColumns();
  const _newColumns: any = [];
  forEach(keys(activeColumns), propName => {
    const col = activeColumns[propName] || {};
    _newColumns.push({
      Header: getHeader(properties[propName], propName),
      accessor: propName,
      HeaderText: properties[propName],
      width: col.width || 250,
      Cell: getCell(col.template, col.ratingColors || {}),
      ...defaultColumnCommonValues,
      ...col,
      ...getFilter(col.Filter, col.filterValues, col.filterPlaceholder),
      ...{ ...(propName === 'identifier' ? { fixed: 'left' } : {}) },
    });
  });
  return _newColumns;
};

const DefaultCell = styled.span`
  color: black;
  height: 30px;
`;

const DefaultHeader = styled.div`
  white-space: pre-line !important;
  word-wrap: break-word;
`;

export const ErrorDetailsColumns: DataGridColumn[] = processColumnsConfig(ErrorDetailsProperties);
